<template>
    <div class="login-page">
        <div class="login-box">
            <div class="login-content">
                <div class="element-div">
                    <div class="login-title">
                        {{$t('loginPage.reset.title')}}
                    </div>
                    <Form ref="loginForm" :model="loginForm" :rules="ruleCustom" :label-width="0" class="login-formstyle">
                        
                        <FormItem  class="itemss" prop="email">
                            <div class="login-names">
                               <Icon type="ios-person-outline" size='24' />
                            </div>
                            <input type="text" :placeholder="$t('loginPage.userName')" v-model.trim="loginForm.email" disabled @keyup.enter="loginSubmit"/>
                        </FormItem>

                        <FormItem class="itemss" prop="password">
                              <div class="login-names">
                               <Icon type="ios-unlock-outline"  size='24'/>
                            </div>
                            <div style="display:flex;align-items: center;width:100%;position:relative;">
                                <input 
                                    :type="showPassword ? 'text' : 'password'"  
                                    maxlength="20" 
                                    :placeholder="$t('topCon.NewPassword')" 
                                    v-model.trim="loginForm.password" 
                                    @keyup.enter="loginSubmit"
                                    style="width:100%;"
                                />
                                <Icon 
                                    :type="!showPassword ? 'ios-eye-off' : 'ios-eye'" 
                                    size="20" 
                                    @click="togglePasswordVisibility"
                                    style="position:absolute;right:10px;cursor:pointer;color:#515a6e;"
                                />
                            </div>
                            
                        </FormItem>

                        <FormItem class="itemss" prop="newPasswordConfirm">
                              <div class="login-names">
                               <Icon type="ios-unlock-outline"  size='24'/>
                            </div>
                            <div style="display:flex;align-items: center;width:100%;position:relative;">
                                <input 
                                    :type="showPassword1 ? 'text' : 'password'"  
                                    maxlength="20" 
                                    :placeholder="$t('topCon.NewPassword1')" 
                                    v-model.trim="loginForm.newPasswordConfirm" 
                                    @keyup.enter="loginSubmit"
                                    style="width:100%;"
                                />
                                <Icon 
                                    :type="!showPassword1 ? 'ios-eye-off' : 'ios-eye'" 
                                    size="20" 
                                    @click="togglePasswordVisibility1"
                                    style="position:absolute;right:10px;cursor:pointer;color:#515a6e;"
                                />
                            </div>
                        </FormItem>

                        <FormItem  class="login-btn">
                            <Button :loading="disabled"  @click="loginSub('loginForm')" class="login-btn-sub">{{$t('confirm')}}</Button>
                        </FormItem>
                    </Form>
                </div>
            </div>
        </div>


    </div>
</template>
<script>
/**
 * 重置密码
 */
import isValid from '../../common/isValid.js';
import common from '@/common/common.js';
import {mapMutations} from 'vuex'
import {Message} from 'view-design'
    export default {
        data() {
            return {
                disabled:false,//禁用确定按钮
                showPassword: false,
                showPassword1: false,
                loginForm: {//表单数据
                    email:'',
                    resetCode:'',
                    lang:'',
                    password:"",
                    newPasswordConfirm:"",
                }
            }
        },
        computed:{
            ruleCustom(){
                return  {//验证
                    email: [
                        { required: true, message: this.$t('required'), trigger: 'blur' }
                    ],
                    password:[
                         {required: true, message: this.$t('required'), trigger:'blur' },
                         { type: 'string', pattern: /^[0-9a-zA-Z]{6,20}$/, message: this.$t('ruleCustom.pwd'), trigger:'blur'},
                        //  { type: 'string', pattern: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{6,10}$/, message: this.$t('ruleCustom.pwd'), trigger:'blur'},
                    ],
                    newPasswordConfirm:[
                         {required: true, message: this.$t('required'), trigger:'blur' },
                         { type: 'string', pattern: /^[0-9a-zA-Z]{6,20}$/, message: this.$t('ruleCustom.pwd'), trigger:'blur'},
                        //  { type: 'string', pattern: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{6,10}$/, message: this.$t('ruleCustom.pwd'), trigger:'blur'},
                    ], 
                }
            }

        },
        watch:{  
           
                
        },
        mounted(){
            this.loginForm.email = this.$route.query.email
            this.loginForm.resetCode = this.$route.query.code
            this.loginForm.lang = this.$route.query.lang
        },
        methods: {
            togglePasswordVisibility() { 
                this.showPassword = !this.showPassword;
            },
            togglePasswordVisibility1() { 
                this.showPassword1 = !this.showPassword1;
            },
             loginSub (name) {//提交表单
                this.$refs[name].validate((valid) => {
                    if (valid) {
                        this.disabled = true;
                        
                        if(this.loginForm.password != '' && this.loginForm.newPasswordConfirm != ''){{
                            if(this.loginForm.password != this.loginForm.newPasswordConfirm){
                                Message.error({
                                  content:this.$t('formRules.twoPassword_notMatch'),
                                  onClose: ()=>{this.disabled = false;}
                                })
                                return false
                            }
                        }}

                        this.axios.post(this.config.urlArray.resetPassword,this.loginForm).then((result) => {
                                Message.success({
                                   content:result.data.data,
                                })
                                
                                setTimeout(()=>{
                                    this.disabled = false;
                                    this.resetForm();
                                    const clearCookies = document.cookie.split(';')
                                    .forEach(cookie => document.cookie = 
                                    cookie.replace(/^ +/, '')
                                    .replace(/=.*/, `=;expires=${new Date(0).toUTCString()};path=/`));
                                    // document.cookie = "Authorization=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
                                    this.$router.replace({ name: 'login' })
                                },2000)
                           
                        }).catch((err) => {
                             this.disabled = false
                           
                        });
                    }
                })
            },
            loginSubmit(event) { // enter快捷键
                event = event || window.event;
                if (event.keyCode === 13) {
                    this.loginSub('loginForm');
                }
            },
             resetForm () {//重置表单
                this.$refs.loginForm.resetFields();//重置表单
                this.disabled = false;//恢复提交按钮为激活状态
                Object.keys(this.loginForm).forEach(key=>{this.loginForm[key]=''})
            }
           
        }
    }
</script>
<style  lang='scss' scoped>
.forgetPwd{
    cursor: pointer;
    color: #029789;
}
#app {
    width: 100%;
    height: 100%;
}
.ident-pos{
    margin-top: 8px;
}
.type-css{
    width: 152px;margin-left:15px;float: right;
}
.login-page {
    width: 100%;
    height: 100vh;
    position: relative;
}
.login-content {
    height: 100%;
    background: #fff;
    flex: 1;
    box-sizing: border-box;
    display: flex;
    align-content: center;
    justify-content: center;
    .ivu-input{
        border: none !important;
    }
}
.login-box{
    position: absolute;
    width: 1000px;
    height: 550px;
    margin: auto;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    align-items: center;
    border-radius: 10px;
    overflow: hidden;
}
.shop-title{
    flex: 1;
    background: #CDFFF5;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    img{
        width: 390px;
    }
}
.login-title {
    width: 345px;
    line-height: 50px;
    text-align: center;
    font-size: 24px;
    margin: 0 auto;
    color: #02ACA2;
    margin-top: 20%;
    margin-bottom: 30px;
}

.login-btn {
    width: 100%;
    height: 40px;
    margin-top: 10px;
}
.login-btn-sub {
    width: 100%;
    background: #02ACA2;
    color: #fff;
    height: 40px;
    margin-top: 20px;
}
.login-names {
    width: 110px;
    padding-left: 10px;
}
.login-imgs {
    margin-left: 10px;
    height: 38px;
}
.login-support {
    width: 100%;
    text-align: center;
    font-size: 12px;
    margin-top: 30px;
}
.ivu-form-item {
    margin-bottom: 30px !important;
}
/*  -------------------------------------------------  */
.forget-pwd>span {
    cursor: pointer;
}
.login-page{
    background:#F5F5F7 url("../../assets/login/bc_img.png")  !important;
    background-size:100% 100%;
}
.shop-title1{
    font-size:29px;
    color:black;
    margin-bottom:35px;
    
}
.shop-title2{
    width:368px;
    line-height:30px;
    font-size:16px;
    color:#A7A7A7;
}
.itemss{
    width:100%;
    display:flex;
    border:1px solid #DDDDDD;
    flex-wrap:nowrap;
    height: 40px;
    align-items: center;
    input{
        border: none;
        width: 100%;
        outline: none;
    }
}
.ivu-form-item-error .ivu-input{
    height: 38px;
    border:none !important;
}
// >>>.ivu-input{
//     height: 38px !important;
//     border:none !important;
// }
</style>
<style>
.login-page .ivu-form-item-content{
    margin-left: 0 !important;
}
.login-page .ivu-form-item-content{
    display: flex;
    width:100%;
    justify-items:center;
}
.forget-pwd {
    text-align: right;
    padding: 15px 0;
    font-size: 14px;
    /* cursor: pointer; */
    color: #666666;
    width:345px;
    height:50px;
}
/* ----------------------- */

</style>


<style lang="less" scoped>
// .login-title{
//     background-color: @itemBgc;
// }
</style>